<template>
  <section>
    <b-form-input class="i-100" v-model="searchText" :placeholder="$t('SEARCH')"></b-form-input>

    <div class="clearfix documentTitle">
      <div class="information w-light d-none d-lg-table-cell">
        {{ $t('DOCUMENT.NAME') }}
      </div>
      <div class="extrainformation w-light d-none d-lg-table-cell">
        {{ $t('DCLIDENTITY') }}
      </div>
      <div class="extrainformation w-light d-none d-lg-table-cell">
        {{ $t('TEMPLATES.DRAFT.LAST_UPDATE') }}
      </div>
    </div>

    <b-card no-body class="mt-2">
      <template-draft-item v-for="(item,index) in draftlist" :item="item" :key="index"></template-draft-item>
    </b-card>

    <b-card v-if="items.length === 0" no-body>
      <b-card-body class="m-4">{{ $t('TEMPLATES.NO_TEMPLATES')}}</b-card-body>
    </b-card>

    <b-pagination
      class="mt-2"
      v-model="currentPage"
      :total-rows="totalItems"
      :per-page="limit"
      align="center"
      @input="getDrafts"
    >
      <template v-slot:first-text>{{$t("PAGINATION.FIRST")}}</template>
      <template v-slot:prev-text>{{$t("PAGINATION.PREV")}}</template>
      <template v-slot:next-text>{{$t("PAGINATION.NEXT")}}</template>
      <template v-slot:last-text>{{$t("PAGINATION.LAST")}}</template>
    </b-pagination>
  </section>
</template>
<script>
import TemplateDraftItem from "@/components/Templates/TemplateDraftItem";
export default {
  components: {
    TemplateDraftItem
  },
  data() {
    return {
      currentPage: 1,
      limit: 7,
      items: [],
      totalItems: 0,
      searchText: "",
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    getDrafts: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/templates/drafts/list", {
          page: this.currentPage,
          limit: this.limit,
          searchText: this.searchText
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    }
  },
  computed: {
    draftlist: function() {
      let filters = [];
      this.items.forEach(element => {
        if (element.documentVersion.published === 0) {
          filters.push(element);
        }
      });
      return filters;
    }
  },
  watch: {
    searchText: function() {
      if (this.searchText.length == 0) {
        this.getDrafts();
      }
      if (this.searchText.length >= 3) {
        this.getDrafts();
      }
    }
  },
  created: function() {
    this.getDrafts();
  }
};
</script>
<style>
</style>